<template>
    <div>
        <b-tabs class="emisiones" v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">Comercio</h6>
                </template>
                <template v-if="tabIndex == 0">
                    <comercio :tipopdv="tabIndex"></comercio>
                </template>
            </b-tab>
            <b-tab title="Grifos">
                <template v-if="tabIndex == 1">
                    <comercio :tipopdv="tabIndex"></comercio>
                </template>
            </b-tab>
            <b-tab title="Tienda">
                <template v-if="tabIndex == 2">
                    <comercio :tipopdv="tabIndex"></comercio>
                </template>
            </b-tab>
            <b-tab title="Casa Cambio">
                <template v-if="tabIndex == 3">
                    <casa-cambio></casa-cambio>
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import Comercio from '@/components/factura/EmisionRapida'
import CasaCambio from '@/components/factura/CasaCambio'
    export default {
        name: 'Market',
        components: {
            Comercio,
            CasaCambio
        },
        data: () => {
            return {
                tabIndex: 0,
            }
        }
    }
</script>

<style lang="scss" scoped>
    .emisiones{
        margin-top: -1%;
    }
    .colorEmision {
        font-weight: bold;
        color: #00004d;
    }
</style>